import { render, staticRenderFns } from "./AutocompleteWrapper.vue?vue&type=template&id=d37a5718&scoped=true"
import script from "./AutocompleteWrapper.vue?vue&type=script&lang=js"
export * from "./AutocompleteWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d37a5718",
  null
  
)

export default component.exports